module.exports = __webpack_public_path__ + "static/media/logoConquerBusiness.6a569099.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logoConquerBusiness.svg
// module id = 231
// module chunks = 0